import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
class EdLoadingBars extends Vue {

  public rows: number = 0;

  setRows() {
    let el: any = this.$el;
    let height = Number(el.offsetHeight);
    this.rows = Math.floor((height - 10)/35);
    this.rows = this.rows <= 0 ? 1 : this.rows;
  }

  mounted() {
    this.setRows();
  }

}

export default Vue.component('ed-loading-bars', EdLoadingBars);